import React, { Component } from 'react';
import { Table, Alert } from 'reactstrap';
import ItemClick from './ItemClick';
import { _getListClicks } from '../../../../../services/apis/AdminAffiliate';
import Pages from '../pagination/Pages';
import {changeQuerySearch, parseSearchQuery} from "../../../../../helpers/routes/RouterHelper"

const getInitPage = () =>{
    const parsed = parseSearchQuery();
    return !!parsed.page ? parseInt(parsed.page, 10) : 1;
}

class ListRefPage extends Component {
    state = {
        listClicks: [],
        error: '',
        total: 0,
        pages: {
            page: getInitPage(),
            limit: 10,
            maxPage: 1
        }
    }

    componentDidMount() {
        this.getListClicks();
    }

    componentDidUpdate(preProps, preState) {
        const { page } = this.state.pages;
        if (preState.pages.page !== page) {
            this.getListClicks();
        }
    }

    getListClicks = () => {
        const { pages } = this.state;
        const { limit, page } = pages;
        _getListClicks(pages)
            .then((result) => {
                if (result.success) {
                    this.setState({
                        listClicks: result.data.docs,
                        pages: {
                            page,
                            limit,
                            maxPage: result.data.pages
                        },
                        total: result.data.total,
                        error: ''

                    });
                } else {
                    this.setState({
                        error: result.message
                    });
                }
            })
            .catch((error) => {
                this.setState({
                    error: error.message
                });
            });
    }

    handleGoToPage = (index) => {
        const { limit, maxPage } = this.state.pages;
        changeQuerySearch({page: index});
        this.setState({
            pages: {
                page: index,
                limit,
                maxPage
            }
        })
    }

    render() {
        const { listClicks, error, pages,total } = this.state;

        return (
            <div className="ListClicksPage">
                {
                    !!error ? <Alert color="danger">{error}</Alert> : ''
                }
                <h2>Clicks Statistic({total})</h2>
                <Table>
                    <thead>
                        <tr>
                            <th>NAME</th>
                            <th>EMAIL</th>
                            <th>REFERRAL LINK</th>
                            <th>TIME</th>
                            <th>IP</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            listClicks.map((itemClick, index) => {
                                return (
                                    <ItemClick key={index} dataClick={itemClick} />
                                )
                            })
                        }
                    </tbody>
                </Table>

                <Pages
                    pages={pages}
                    handleGoToPage={this.handleGoToPage}
                />
            </div>
        );
    }
}

export default ListRefPage;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/affiliate/list-clicks/ListClicksPage.js